export const contactReactivationBlockTranslations = {
  reactivate: `cng-contact_reactivation_block-reactivate`,
  reactivated: `cng-contact_reactivation_block-reactivated`,
  relinkNeeded: {
    title: `cng-contact_reactivation_block-relink_needed-title`,
    reason: {
      differentPartner: `cng-contact_reactivation_block-relink_needed-reason-different_partner`,
      noLocation: `cng-contact_reactivation_block-relink_needed-reason-no_location`,
    },
    confirm: `cng-contact_reactivation_block-relink_needed-confirm`,
    reject: `cng-contact_reactivation_block-relink_needed-reject`,
  },
}
